import SectionHero from "components/SectionHero/SectionHero";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionOurFeatures from "components/SectionOurFeatures/SectionOurFeatures";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { TaxonomyType } from "data/types";
import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
import SectionGridCategoryBox from "components/SectionGridCategoryBox/SectionGridCategoryBox";
import SectionBecomeAnAuthor from "components/SectionBecomeAnAuthor/SectionBecomeAnAuthor";
import SectionVideos from "./SectionVideos";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { AppDispatch, RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import TestimonialsSection from "containers/PageContact/TestimonialsSection";
import RetreatCard from "components/SectionSliderNewCategories/RetreatCard";
import HowItWorks from "components/SectionSliderNewCategories/HowItWorks";
import HomePropeties from "components/SectionSliderNewCategories/HomePropeties";
import CommunityHighLights from "./components/Communityhighlights";
import UpcomingEvents from "./components/Upcomingevents";
import events from "../../data/events";
import CommunityGallery from "./components/Communitygallery";
import { galleryImages } from "../../images/community";
import GoogleReviewsDisplay from "./components/Googlereviewsdisplay";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import SEO from "components/SEO/SEO";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

//import { getFeaturedProperty } from "../../redux/reducers/Properties/PropertiesSlice";

import { getFeaturedProperty } from "../../redux/reducers/Properties/PropertiesSlice";
import HowNomaroofWorks from "./components/HowNomaroofWorks";

const DEMO_CATS: TaxonomyType[] = [
  {
    id: "1",
    href: "#",
    name: "New York",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/64271/queen-of-liberty-statue-of-liberty-new-york-liberty-statue-64271.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
  },
  {
    id: "2",
    href: "#",
    name: "Singapore",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/7740160/pexels-photo-7740160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "2",
    href: "#",
    name: "Paris",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/739407/pexels-photo-739407.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "2",
    href: "#",
    name: "London",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
  },
  {
    id: "2",
    href: "#",
    name: "Tokyo",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/4151484/pexels-photo-4151484.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
  },
  {
    id: "2",
    href: "#",
    name: "Maldives",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/3250613/pexels-photo-3250613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
];

const DEMO_CATS_2: TaxonomyType[] = [
  {
    id: "1",
    href: "#",
    name: "Enjoy the great cold",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/5764100/pexels-photo-5764100.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
  },
  {
    id: "222",
    href: "#",
    name: "Sleep in a floating way",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/2869499/pexels-photo-2869499.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "3",
    href: "#",
    name: "In the billionaire's house",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/7031413/pexels-photo-7031413.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "4",
    href: "#",
    name: "Cool in the deep forest",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/247532/pexels-photo-247532.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "5",
    href: "#",
    name: "In the billionaire's house",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://images.pexels.com/photos/7031413/pexels-photo-7031413.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
];

function PageHome() {
  const dispatch = useDispatch<AppDispatch>();
  
  const { featuredProperty, loading } = useSelector(
    (state: RootState) => state.property
  );

  // ✅ Fetch ONCE on mount only
  useEffect(() => {
    dispatch(getFeaturedProperty());
  }, []); // ✅ Empty dependency array - only runs once

  return (
    <div className="nc-PageHome relative overflow-hidden">
        <SEO
        title="Student Accommodation in Lima, Peru"
        description="Find rooms, studios, apartments and university dorms for students and Erasmus in Lima, Peru. Affordable, verified, and easy to book online."
        canonical="/"
      />
      <BgGlassmorphism />

      <div className="container relative space-y-6 mb-24 lg:space-y-8 lg:mb-28">
        {/* ✅ Pass featuredProperty to SectionHero */}
        <SectionHero 
          className="lg:pb-16" 
          featuredProperties={featuredProperty}
        />

        <CommunityHighLights />
        <RetreatCard />

        {/* ── Experiences CTA Banner ── */}
{/* <div className="relative rounded-3xl overflow-hidden">

  <div className="absolute inset-0">
    <img
      src="https://images.pexels.com/photos/1271619/pexels-photo-1271619.jpeg"
      alt="Peru experiences"
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
  </div>

 
  <div className="relative px-10 py-16 lg:py-20 lg:px-16 max-w-xl">
    <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#f5694b] text-white text-xs font-bold uppercase tracking-widest rounded-full mb-6">
      ✦ New
    </span>
    <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight mb-4">
      Group Adventures <br />Across Peru
    </h2>
    <p className="text-white/80 text-base leading-relaxed mb-8">
      Trek to Laguna 69, explore Huaraz, and travel with a community of students and young professionals. Curated trips, real connections.
    </p>
    <Link
      to="/experiences"
      className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-gray-900 hover:bg-[#f5694b] hover:text-white font-semibold rounded-full shadow-lg transition-all duration-300 hover:scale-105"
    >
      Explore Experiences
      <ChevronRight className="w-4 h-4" />
    </Link>
  </div>
</div> */}

        {/* ✅ ADD: How Nomadroof Works Section */}
        <HowNomaroofWorks />

        {/* Featured Properties Section */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionGridFeaturePlaces stayListings={featuredProperty} />
        </div>

        {/* <TestimonialsSection /> */}

        <GoogleReviewsDisplay 
          title="What Our Students Say"
          subtitle="Real reviews from our community"
          maxReviews={10}
          accentColor="#f5694b"
        />
      </div>
    </div>
  );
}

export default PageHome;